import { Link } from '@inertiajs/react'
import PublicLayout from '../layouts/PublicLayout'
import Monogram from '../components/Monogram'
import FollowButton from '../components/FollowButton'

const STATUS_CLASS = { V: 'done', E: 'done', D: 'loss' }

function opponentFor(team, m) {
  return m.home && m.home.slug === team.slug ? m.away : m.home
}

function scoreFor(team, m) {
  if (m.homeScore == null || m.awayScore == null) return '–'
  const isHome = m.home && m.home.slug === team.slug
  return isHome ? `${m.homeScore}–${m.awayScore}` : `${m.awayScore}–${m.homeScore}`
}

export default function Team({
  currentEdition,
  editions,
  team,
  groupName,
  position,
  points,
  results = [],
  groupRows = [],
  vapidPublicKey,
}) {
  if (!team) {
    return (
      <PublicLayout currentEdition={currentEdition} editions={editions} active="equipas" />
    )
  }

  return (
    <PublicLayout currentEdition={currentEdition} editions={editions} active="equipas" title={team.name}>
      <div className="team-hero">
        <Monogram team={team} size={72} />
        <div>
          <h3>{team.name}</h3>
          <div className="sub">Grupo {groupName}</div>
        </div>
        <FollowButton teamId={team.id} vapidPublicKey={vapidPublicKey} />
        <div className="stat">
          <div><b>{points ?? '–'}</b><span>Pontos</span></div>
          <div><b>{position ? `${position}º` : '–'}</b><span>Grupo {groupName}</span></div>
        </div>
      </div>

      <div className="two-col">
        <div>
          <div className="sechead" style={{ marginBottom: 12 }}>
            <h3 style={{ fontSize: 20 }}>Percurso</h3>
            <div className="rule"></div>
          </div>
          <div className="adm-list">
            {results.map((m) => {
              const opp = opponentFor(team, m)
              return (
                <Link className="adm-fx" key={m.gameNumber} href={`/${currentEdition.slug}/jogo/${m.gameNumber}`}>
                  <span className="gn">J{m.gameNumber}</span>
                  <span className="tm">
                    vs {opp ? opp.name : m.label}{' '}
                    <span style={{ color: 'var(--ink-soft)', fontWeight: 500 }}>
                      · {m.time}{m.field ? ` · C${m.field}` : ''}
                    </span>
                  </span>
                  {m.outcome && <span className={`st ${STATUS_CLASS[m.outcome] || 'todo'}`}>{m.outcome}</span>}
                  <span className="rr">{scoreFor(team, m)}</span>
                </Link>
              )
            })}
          </div>
        </div>

        <div>
          <div className="sechead" style={{ marginBottom: 12 }}>
            <h3 style={{ fontSize: 20 }}>No grupo</h3>
            <div className="rule"></div>
          </div>
          <div className="placement">
            {groupRows.map((r) => (
              <div
                className="pl"
                key={r.team.slug}
                style={r.isTeam ? { background: 'rgba(12,81,50,.07)' } : undefined}
              >
                <span className="pos" style={r.isTeam ? { color: 'var(--pitch)' } : undefined}>
                  {r.position}º
                </span>
                <Monogram team={r.team} size={22} />
                {r.isTeam ? <b>{r.team.name}</b> : r.team.name}
                <span
                  style={{
                    marginLeft: 'auto',
                    fontWeight: 700,
                    color: r.isTeam ? 'var(--pitch)' : undefined,
                  }}
                >
                  {r.points}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PublicLayout>
  )
}
